import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type GetLocationDefaultHoursRequest = {
  tmsID: number;
  locationExternalId: string;
  date: string; // YYYY-MM-DD or MM/DD/YYYY
  originOrDest: 'origin' | 'dest';
};

export type GetLocationDefaultHoursResponse = {
  openTime: string; // HH:MM
  closeTime: string; // HH:MM
  timezone?: string; // IANA e.g. America/New_York when API provides it
};

/**
 * Fetch location dock working hours (open/close) for a given date from 3G getDefaultDate.
 * Used when the user changes pickup or delivery location/date so we can show read-only hours.
 */
export async function getLocationDefaultHours(
  body: GetLocationDefaultHoursRequest
): Promise<Result<GetLocationDefaultHoursResponse, ApiError>> {
  try {
    const response = await axios.post<GetLocationDefaultHoursResponse>(
      '/locations/default-hours',
      body
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getLocationDefaultHours' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get location default hours' });
    }

    return err({
      message:
        error.response?.data?.message ?? 'Failed to get location default hours',
      status: error.response?.status,
    });
  }
}
